import * as ActionCable from '@rails/actioncable';
window.ActionCable = ActionCable;

import cableSetup from './components/cable.ts';
cableSetup();
